import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles/index';
// import Button from 'material-ui/Button';
import Typography from 'material-ui/Typography';

const styles = ({ spacing: { unit } }) => ({
    root: {
        width: '100%',
    },
    button: {
        marginLeft: unit * 2,
    },
    photo: {
        width: '200px',
        height: '200px',
        borderRadius: '50%',
    },
    container: {
        textAlign: 'center',
    },
});

function ApplicantVerified(props) {
    return (
        <div className={props.classes.container}>
            <img src={props.photoUrl} alt="" className={props.classes.photo} />
            <Typography>
                Congratulation!
            </Typography>
            <Typography>
                Verification of your identity has passed successfully
            </Typography>
        </div>
    );
}

ApplicantVerified.propTypes = {
    photoUrl: PropTypes.string.isRequired,
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ApplicantVerified);



// WEBPACK FOOTER //
// ./src/app/FormStepper/ApplicantIdVerification/components/ApplicantVerified.js